import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ff96d268&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff96d268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff96d268')) {
      api.createRecord('ff96d268', component.options)
    } else {
      api.reload('ff96d268', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ff96d268&scoped=true", function () {
      api.rerender('ff96d268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/baseConfig/proportionalAllocation/index.vue"
export default component.exports